const PRODUCTION_SUBDOMAIN = 'www'
const PRODUCTION_ACCOUNTS_SUBDOMAIN = 'accounts'
const PREPROD_ACCOUNTS_SUBDOMAIN = 'accounts.preprod'

export function useAuthOrigin() {
  const { hostname, origin } = window.location
  // if hostname contains `accounts`, we are already on the accounts subdomain, we do nothing.
  if (hostname.includes('accounts')) {
    return origin
  }

  const [subdomain] = hostname.split('.')

  if (subdomain === PRODUCTION_SUBDOMAIN) {
    return origin.replace(subdomain, PRODUCTION_ACCOUNTS_SUBDOMAIN)
  }

  // TEMPORARY: For DSE, use preprod accounts subdomain for both pages and endpoints
  // Once front-accounts is compatible with DSE, we can remove this for pages (but not for endpoints, we'll need to differentiate)
  if (subdomain.includes('dse-pr-front-apps')) {
    // DSE URLs look like: https://dse-pr-front-apps-1234.dse.backmarket.fr
    return origin.replace(`${subdomain}.dse`, PREPROD_ACCOUNTS_SUBDOMAIN)
  }

  return origin.replace(subdomain, PREPROD_ACCOUNTS_SUBDOMAIN)
}
